import { LIVE_METRIC_SAMPLES_MAX } from "./config";

export class MetricSamples {
  private samples: number[] = [];

  push(value: number): void {
    if (!Number.isFinite(value) || value < 0) return;
    this.samples.push(value);
    if (this.samples.length > LIVE_METRIC_SAMPLES_MAX) {
      this.samples.splice(0, this.samples.length - LIVE_METRIC_SAMPLES_MAX);
    }
  }

  get count(): number {
    return this.samples.length;
  }

  clear(): void {
    this.samples.length = 0;
  }

  summary(): { last: number; avg: number; p95: number } | null {
    if (this.samples.length === 0) return null;
    const last = this.samples[this.samples.length - 1];
    const sum = this.samples.reduce((a, b) => a + b, 0);
    const avg = sum / this.samples.length;
    const sorted = [...this.samples].sort((a, b) => a - b);
    const idx = Math.min(sorted.length - 1, Math.max(0, Math.ceil(sorted.length * 0.95) - 1));
    const p95 = sorted[idx];
    return {
      last: roundMs(last),
      avg: roundMs(avg),
      p95: roundMs(p95),
    };
  }
}

const roundMs = (n: number): number => Math.round(n);
